module.exports = __webpack_public_path__ + "static/img/pro_tab7.26ffcd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro_tab7.jpg
// module id = P2ES
// module chunks = 171